/**
 * SEO 配置 - chat (Français)
 */

export default {
    chat: {
        title: 'Chat IA - Assistant Multi-Modèles | WeryAI',
        description:
            'Discutez avec les meilleurs modèles IA sur WeryAI. Comparez les réponses côte à côte dans plusieurs fenêtres. Générez images, vidéos et musique depuis un seul espace.',
        keywords:
            'chat IA, assistant IA, chat multi-modèles, chatbot IA, comparer modèles IA, chat IA côte à côte, alternative GPT, espace de travail IA, WeryAI',
        og_title: 'Chat IA - Assistant Multi-Modèles | WeryAI',
        og_description:
            'Discutez avec les meilleurs modèles IA et comparez les réponses côte à côte. Générez images, vidéos et plus. Essayez gratuitement sur WeryAI.',
        twitter_title: 'Chat IA - Assistant Multi-Modèles | WeryAI',
        twitter_description:
            'Discutez avec les meilleurs modèles IA et comparez les réponses côte à côte. Générez images, vidéos et plus. Essayez gratuitement sur WeryAI.',
    },
}
